import type { Device } from "@/api/generated/model"

/**
 * The one definition of "offline" (LLD §7.6), shared by the alert bell, the
 * overview tile, the device list and the admin queue card: the API's own
 * `online` flag (the backend's overdue-heartbeat rule) on an enabled device.
 * A disabled device is not offline; it is disabled.
 */
export const isOffline = (d: Pick<Device, "enabled" | "online">): boolean => d.enabled && !d.online
